import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

const ErrorPopup = ({ title, children, showError, setShowError }) => {
  useEffect(() => {
    if (!showError) return;
    const timer = setTimeout(() => setShowError(false), 6000);
    return () => clearTimeout(timer);
  }, [showError]);

  if (!showError) return null;

  return (
    <>
      <style>{`
        @keyframes slideInToast {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div style={{
        position: "fixed", bottom: "24px", right: "24px", zIndex: 9999,
        maxWidth: "380px", width: "calc(100vw - 48px)",
        background: "#fff", borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.16)",
        borderLeft: "4px solid #c62828",
        overflow: "hidden",
        animation: "slideInToast 0.25s ease",
      }}>
        {/* Progress bar */}
        <div style={{
          position: "absolute", top: 0, left: 0, height: "3px",
          background: "#c62828", width: "100%",
          animation: "shrinkBar 6s linear forwards",
        }} />
        <style>{`@keyframes shrinkBar { from { width: 100%; } to { width: 0%; } }`}</style>

        <div style={{ padding: "16px 18px", display: "flex", gap: "12px", alignItems: "flex-start" }}>
          {/* Icon */}
          <div style={{
            width: "34px", height: "34px", borderRadius: "8px",
            background: "#ffebee", color: "#c62828", flexShrink: 0,
            display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem",
          }}>
            <FontAwesomeIcon icon={faCircleExclamation} />
          </div>

          {/* Content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: "0.92rem", color: "#212121", marginBottom: "3px" }}>
              {title || "Something went wrong"}
            </div>
            {children && (
              <div style={{ fontSize: "0.82rem", color: "#616161", lineHeight: 1.5 }}>
                {children}
              </div>
            )}
          </div>

          {/* Close */}
          <button onClick={() => setShowError(false)} style={{
            background: "none", border: "none", cursor: "pointer",
            color: "#bdbdbd", padding: "0", flexShrink: 0,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "0.9rem", marginTop: "2px",
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>
    </>
  );
};

export default ErrorPopup;
